const MonthlyReportTable = ({ employeeAttendance }) => {
  console.log(employeeAttendance)
  return (
    <div className="">
      <div className="w-full h-[calc(100vh-170px)] overflow-y-auto mt-2 md:mt-3">
        <table className="min-w-max w-full border border-gray-300 pt-5">
          <tbody>

            {employeeAttendance && Object.keys(employeeAttendance).map((dept) => (
              <>
                <tr>
                  <td colSpan={8}>
                    <div className="flex justify-end">
                      <p className="py-4 px-3 border-b font-bold text-[18px] capitalize bg-gray-300 text-black rounded-full text-center w-fit">
                        {dept}
                      </p>
                    </div>
                  </td>
                </tr>

                {employeeAttendance[dept].map((employee) => (
                  <>
                    <tr className="">
                      <td className="flex justify-start">
                        <p className="py-4 px-3 border-b font-bold text-[18px] capitalize bg-gray-300 text-black rounded-r-full text-center min-w-[50%]">
                          {employee.firstname}
                        </p>
                      </td>
                    </tr>
                    {(() => {
                      let totalHours = 0;
                      let totalMinutes = 0;
                      let totalLate = 0;
                      let totalAbsent = 0;
                      let totalPresent = 0;
                      let totalHoliday = 0;
                      let totalLeave = 0;
                      let totalDays = 0;
                      employee.attendanceData.forEach((attendance) => {
                        if (attendance.totalHours) {
                          const [hours, minutes] = attendance.totalHours.split(":").map(Number);
                          totalHours += hours;
                          totalMinutes += minutes;
                        }
                        if (attendance.late == "Late") {
                          totalLate += 1
                        }
                        if (attendance?.entryTime != null) {
                          totalPresent += 1
                        }
                        if (attendance.dayType === "Absent") {
                          totalAbsent += 1
                        }
                        if (attendance.dayType === "Leave") {
                          totalLeave += 1
                        }
                        if (!attendance?.entryTime &&
                          attendance?.dayType === "Holiday" &&
                          attendance?.remark !== "SATURDAY" &&
                          attendance?.remark !== "SUNDAY") {
                          totalHoliday += 1
                        }
                        if (attendance?.entryTime || (attendance.dayType !== "Weekend" &&
                          attendance.remark !== "SATURDAY" &&
                          attendance.remark !== "SUNDAY")) {
                          totalDays += 1
                        }
                      });
                      totalHours += Math.floor(totalMinutes / 60);
                      totalMinutes = totalMinutes % 60;
                      const formattedMinutes = String(totalMinutes).padStart(2, "0");
                      // console.log("totalHours",totalHours)
                      return (
                        <>

                          <tr className="bg-gray-300 ">
                            <td className="px-3 py-2 border-b font-bold">
                              <span className="mr-3">Total Days</span>
                              <span>{totalDays}</span>
                            </td>
                            <td className="px-3 py-2 border-b font-bold">
                              <span className="bg-white px-3 py-2 mr-3">
                                <span className="mr-3">Total Present</span>
                                <span>{totalPresent}</span>
                              </span>
                            </td>
                            <td className="font-bold">
                              <span className="bg-red-300 px-3 py-2 mr-3">
                                <span className="mr-3">Total Absent</span>
                                <span>{totalAbsent}</span>
                              </span>
                            </td>
                            <td className="font-bold">
                              <span className="bg-green-200 px-3 py-2 mr-3">
                                <span className="mr-3">Total Holiday</span>
                                <span>{totalHoliday}</span>
                              </span>
                            </td>
                            <td className="px-3 py-2 border-b font-bold">
                              <span className="px-3 py-2 bg-yellow-100">
                                <span className="mr-3">Total Lates</span>
                                <span>{totalLate}</span>
                              </span>
                            </td>
                            <td className="px-3 py-2 border-b font-bold">
                              <span className="px-3 py-2 bg-purple-300">
                                <span className="mr-3">Total Leaves</span>
                                <span>{totalLeave}</span>
                              </span>
                            </td>
                            <td className="px-3 py-2 border-b font-bold">
                              <span className="mr-3">Fuel Days</span>
                              <span>{`${totalPresent - totalLate}`}</span>
                            </td>
                            <td className="px-3 py-2 bg-blue-300  border-b font-bold">
                              <span className="mr-3">Total Hours</span>
                              {/* <span>{`${totalHours}:${formattedMinutes}`}</span> */}
                              <span>{`${totalHours}`}</span>
                            </td>
                          </tr>
                        </>
                      );
                    })()}
                  </>
                ))}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MonthlyReportTable;
